var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 2V4.26667C10.0013 4.64004 10.0013 4.82672 10.074 4.96933C10.1379 5.09477 10.2399 5.19676 10.3653 5.26067C10.5079 5.33333 10.6946 5.33333 11.068 5.33333H13.3346M6.66797 5.33333H4.0013C3.26492 5.33333 2.66797 5.93029 2.66797 6.66667V12.6667C2.66797 13.403 3.26492 14 4.0013 14H8.0013C8.73768 14 9.33464 13.403 9.33464 12.6667V10.6667M10.668 2H8.8013C8.05457 2 7.6812 2 7.39598 2.14532C7.1451 2.27316 6.94112 2.47713 6.81329 2.72801C6.66797 3.01323 6.66797 3.3866 6.66797 4.13333V8.53333C6.66797 9.28007 6.66797 9.65344 6.81329 9.93865C6.94112 10.1895 7.1451 10.3935 7.39598 10.5213C7.6812 10.6667 8.05457 10.6667 8.8013 10.6667H11.2013C11.948 10.6667 12.3214 10.6667 12.6066 10.5213C12.8575 10.3935 13.0615 10.1895 13.1893 9.93865C13.3346 9.65344 13.3346 9.28007 13.3346 8.53333V4.66667L10.668 2Z",
    stroke: "white",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.ac811bc186f6b39bd63449f824360f7b.svg";
export { ForwardRef as ReactComponent };